import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {useState} from 'react'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {ROUTES} from '../../../../_gori/constants'

export function Footer() {
  const intl = useIntl()

  const [hoveredIcon, setHoveredIcon] = useState<string | null>(null)

  const getIconSrc = (platform: string) => {
    const isHovered = hoveredIcon === platform
    return toAbsoluteUrl(`/media/gori/socials/${platform}${isHovered ? '-hover' : ''}.svg`)
  }

  const socials = [
    {key: 'youtube', url: 'https://www.youtube.com/@ShipBae'},
    {key: 'instagram', url: 'https://www.instagram.com/shipbae_official/'},
    {key: 'linkedin', url: 'https://www.linkedin.com/company/shipbae/'},
    {key: 'facebook', url: 'https://www.facebook.com/people/Gori-Company/61570570597599/'},
  ]

  const productLinks = [
    {label: intl.formatMessage({id: 'SHIPBAE'}), path: ROUTES.PRODUCTS.PRODUCT, active: true},
    {label: intl.formatMessage({id: 'BAEGUARD'}), path: ROUTES.PRODUCTS.INSURANCE, active: true},
    {
      /*
    {
      label: intl.formatMessage({id: 'GORI_SIGNATURE'}),
      path: ROUTES.PRODUCTS.GORI_SIGNATURE,
      active: true,
    },
    {
      label: intl.formatMessage({id: 'SHIPBAE_A1'}),
      path: ROUTES.PRODUCTS.SHIPBAE_A1,
      active: false,
    },
    {label: intl.formatMessage({id: 'BAE'}), path: ROUTES.PRODUCTS.BAE, active: false},
    */
    },
  ]

  const resourceLinks = [
    {label: intl.formatMessage({id: 'BLOG'}), path: ROUTES.RESOURCE.BLOG, active: true},
    {label: intl.formatMessage({id: 'RELEASES'}), path: ROUTES.RESOURCE.RELEASES, active: true},
    {
      label: intl.formatMessage({id: 'HELP_CENTER'}),
      path: ROUTES.HELP_CENTER.BASE,
      active: true,
      external: true,
    },
    {
      label: intl.formatMessage({id: 'GORI_SIGNATURE'}),
      path: ROUTES.PRODUCTS.GORI_SIGNATURE,
      active: true,
    },
    {
      /*    {
      label: intl.formatMessage({id: 'CLAIM_CHECKLIST'}),
      path: ROUTES.FREE_TOOLS.CLAIM_CHECKLIST,
      active: false,
    },
    {
      label: intl.formatMessage({id: 'SHIPPING_CALCULATOR'}),
      path: ROUTES.FREE_TOOLS.SHIPPING_CALCULATOR,
      active: false,
    },
    {label: intl.formatMessage({id: 'SHIPPING_DEMO'}), path: '#', active: false},
    */
    },
  ]

  // const freeToolLinks = [
  //   {label: intl.formatMessage({id: 'CLAIM_CHECKLIST'}), path: ROUTES.FREE_TOOLS.CLAIM_CHECKLIST, active: false},
  //   {
  //     label: intl.formatMessage({id: 'SHIPPING_CALCULATOR'}),
  //     path: ROUTES.FREE_TOOLS.SHIPPING_CALCULATOR, active: false
  //   },
  // ]

  return (
    <footer className='bg-dark mt-auto' role='contentinfo'>
      <div className='container'>
        <div className='public-footer'>
          {/* Top section: 3 columns */}
          <div className='row py-25 mb-12'>
            {/* Left: Logo + tagline */}
            <div className='col-12 col-lg-4 mb-8 mb-lg-0'>
              <Link to='/' aria-label='ShipBae Home'>
                <img
                  src={toAbsoluteUrl('/media/logos/shipbae-gori-logo-white.svg')}
                  alt='ShipBae Powered By Gori.ai'
                />
              </Link>
              <p className='text-white fs-1 mt-6 mb-0 text-uppercase fw-boldest'>
                {intl.formatMessage({id: 'PERSONAL_AI'})}
              </p>
              <p className='text-white fs-1 mb-0 text-uppercase fw-boldest footer-tagline-tight'>
                {intl.formatMessage({id: 'SHIPPING_MANAGER'})}
              </p>
            </div>

            {/* Products */}
            <div className='col-12 col-sm-6 col-lg-2 mb-8 mb-lg-0'>
              <nav aria-label='Products'>
                <span className='text-white fw-bolder text-uppercase mb-7 fs-1 d-block'>
                  {intl.formatMessage({id: 'PRODUCTS'})}
                </span>
                <ul className='list-unstyled'>
                  {productLinks.map((link) => (
                    <li key={link.label} className='mb-4'>
                      {link.active ? (
                        <Link to={link.path} className='text-white footer-link fs-5'>
                          {link.label}
                        </Link>
                      ) : (
                        <span className='text-gray-500 fs-5'>{link.label}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            {/* Resources */}
            <div className='col-12 col-sm-6 col-lg-3 mb-8 mb-lg-0'>
              <nav aria-label='Resources'>
                <span className='text-white fw-bolder text-uppercase mb-7 fs-1 d-block'>
                  {intl.formatMessage({id: 'RESOURCES'})}
                </span>
                <ul className='list-unstyled'>
                  {resourceLinks.map((link) => (
                    <li key={link.label} className='mb-4'>
                      {link.active ? (
                        link.external ? (
                          <a
                            href={link.path}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='text-white footer-link fs-5'
                          >
                            {link.label}
                          </a>
                        ) : (
                          <Link to={link.path} className='text-white footer-link fs-5'>
                            {link.label}
                          </Link>
                        )
                      ) : (
                        <span className='text-gray-500 fs-5'>{link.label}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            {/* Free Tools section - commented out until tools are live
            <div className='col-6 col-sm-4 col-lg-2 mb-8 mb-lg-0'>
              <nav aria-label='Free Tools'>
                <span className='text-white fw-bolder text-uppercase mb-7 fs-1 d-block'>
                  {intl.formatMessage({id: 'FREE_TOOL'})}
                </span>
                <ul className='list-unstyled'>
                  {freeToolLinks.map((link) => (
                    <li key={link.label} className='mb-4'>
                      {link.active ? (
                        <Link to={link.path} className='text-white footer-link fs-5'>
                          {link.label}
                        </Link>
                      ) : (
                        <span className='text-gray-500 fs-5'>{link.label}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
            */}

            {/* Connect */}
            <div className='col-12 col-lg-3 ms-0 ms-lg-auto'>
              <span className='text-white fw-bolder mb-4 fs-3 mt-1 d-block'>
                {intl.formatMessage({id: 'FOLLOW_SHIPBAE'})}
              </span>
              <ul className='social-media-links list-unstyled d-flex flex-row flex-wrap gap-3 mb-7 mt-4'>
                {socials.map((s) => (
                  <li key={s.key}>
                    <a
                      href={s.url}
                      target='_blank'
                      rel='noopener noreferrer'
                      aria-label={`Follow us on ${s.key}`}
                      onMouseEnter={() => setHoveredIcon(s.key)}
                      onMouseLeave={() => setHoveredIcon(null)}
                      onFocus={() => setHoveredIcon(s.key)}
                      onBlur={() => setHoveredIcon(null)}
                    >
                      <img src={getIconSrc(s.key)} alt='' />
                    </a>
                  </li>
                ))}
              </ul>
              <address className='text-white fs-4 fst-normal'>
                <a
                  href='mailto:support@goricompany.com'
                  className='text-white footer-link d-block mb-3'
                >
                  {intl.formatMessage({id: 'SUPPORT_EMAIL'})}
                </a>
                <a href='tel:+18774674244' className='text-white footer-link d-block mb-3'>
                  {intl.formatMessage({id: 'SUPPORT_PHONE'})}
                </a>
                <div>{intl.formatMessage({id: 'COMPANY_ADDRESS_LINE_1'})}</div>
                <div>{intl.formatMessage({id: 'COMPANY_ADDRESS_LINE_2'})}</div>
              </address>
            </div>
          </div>

          {/* Bottom bar */}
          <div className='mb-13 d-flex flex-column flex-sm-row justify-content-center align-items-center'>
            <span className='text-white fs-7 me-6 fw-light'>
              {intl.formatMessage({id: 'COPYRIGHT'}, {year: new Date().getFullYear()})}{' '}
              {intl.formatMessage({id: 'GORI_COMPANY'})}
              {'. '}
              {intl.formatMessage({id: 'ALL_RIGHTS_RESERVED'})}
            </span>
            <nav className='d-flex gap-9 mt-3 mt-sm-0 ms-0 ms-sm-10' aria-label='Legal'>
              <Link to={ROUTES.SERVICE_TERMS.BASE} className='text-white footer-link fs-6'>
                {intl.formatMessage({id: 'TERMS_OF_SERVICE'})}
              </Link>
              <Link to={ROUTES.PRIVACY_POLICY.BASE} className='text-white footer-link fs-6'>
                {intl.formatMessage({id: 'PRIVACY_POLICY'})}
              </Link>
              <button
                type='button'
                className='text-white footer-link fs-6 bg-transparent border-0 p-0 cursor-pointer'
                onClick={() => {
                  if (typeof window.openCookieSettings === 'function') {
                    window.openCookieSettings()
                  }
                }}
              >
                {intl.formatMessage({id: 'DO_NOT_SELL_MY_INFO'})}
              </button>
              <a href='/sitemap.xml' className='text-white footer-link fs-6'>
                {intl.formatMessage({id: 'SITEMAP'})}
              </a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  )
}
